import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { TextWrapper, Wrapper } from "../../../constants/common/StyledGlobalConstants";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

const CamerasAndAccessoriesDetails = ({ camerasAndAccessories, cameras = [] }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;

  return (
    camerasAndAccessories !== "No accessories connected" && (
      <Wrapper flex="1" marginTop={isMobile && "1rem"}>
        <TextWrapper fontSize="1rem" fontWeight="700" lineHeight="1.375rem">
          Cameras and other accessories:
        </TextWrapper>
        <Wrapper marginTop="1rem" fontWeight="400" lineHeight="0.875rem">
          {cameras.length > 0 && (
            <>
              <TextWrapper fontSize="0.875rem" fontWeight="700" lineHeight="1.25rem" marginBottom="0.5rem">
                Camera details
              </TextWrapper>
              {cameras.map((camera) => (
                <TextWrapper marginBottom="0.5rem" key={camera}>
                  {camera.name} camera ESN: {camera.esn}
                </TextWrapper>
              ))}
            </>
          )}
          {camerasAndAccessories.split(",").map((accessory) => (
            <TextWrapper marginBottom="0.5rem" key={accessory}>
              {accessory}
            </TextWrapper>
          ))}
        </Wrapper>
      </Wrapper>
    )
  );
};
CamerasAndAccessoriesDetails.propTypes = {
  camerasAndAccessories: PropTypes.string.isRequired,
  cameras: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      esn: PropTypes.string,
    })
  ),
};

export default CamerasAndAccessoriesDetails;